import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import noImage from "../../../../../Assets/Images/no-image.png";
export default function OfflineUserSmall({ user }) {

  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div className=" StarON  me-2">
        <Link to={`/starprofile/${user.id}`} className="text-light">
          <img
            src={
              user?.image != null
                ? imageCdnUrl + user?.image
                : noImage
            }
            alt=""
            className="star-online-ac"
          />
        </Link>
      </div>
    </>
  );
}
